/**
 * Tonos de los chips de estado de las tablas (DESIGN.md > Semantic status).
 *
 * Un estado se dice con un TONO, no con un color suelto: así "pagada" se ve
 * igual en todas las pantallas. Sin dependencias de Vue.
 *
 * `darkText: false` es para fondos claros (el amarillo de `warning`), donde
 * el texto blanco no se lee.
 */
export const STATUS_TONES = {
    success: { color: 'success darken-1', darkText: true },   // pagada, activo, vinculado
    danger: { color: 'red', darkText: true },                  // cancelada, inactivo
    warning: { color: 'warning', darkText: false },            // vencida, en atraso
    info: { color: 'info', darkText: true },                   // informativo
    pending: { color: 'purple', darkText: true },              // emitida, pendiente de cobro
    neutral: { color: 'grey', darkText: true }                 // sin vincular, sin estado
};

export const DEFAULT_TONE = 'neutral';

/**
 * Color y tinta del chip. Un `color` explícito gana (los catálogos del
 * backend traen el suyo: tipo de salida, estatus de venta); si no, el tono.
 * Un tono desconocido cae en neutral en vez de romper la tabla.
 */
export function resolveChip({ tone, color }) {
    if (color) return { color, darkText: true };
    const found = STATUS_TONES[tone] || STATUS_TONES[DEFAULT_TONE];
    return { color: found.color, darkText: found.darkText };
}

/** Activo / Inactivo: el par que más se repite en los catálogos. */
export function activeChip(active, { activeText = 'Activo', inactiveText = 'Inactivo' } = {}) {
    return active
        ? { label: activeText, tone: 'success' }
        : { label: inactiveText, tone: 'danger' };
}
